<template>
  <div :class="['eid-item-container', { selected: isSelected }]" @click="selectedEid = eidType">
    <div class="radio-button-container">
      <FriedRadioButton
        class="radio-button"
        :model-value="selectedEid"
        :value="eidType"
        :label="label"
        @update:model-value="selectedEid = $event"
      />
      <span v-if="$slots.logo" class="logo">
        <slot name="logo" />
      </span>
    </div>
    <TransitionExpand>
      <div v-if="isSelected" class="slot-container">
        <slot />
      </div>
    </TransitionExpand>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import type { EidType } from '../../types/enums/eid-type';

interface Props {
  eidType: EidType;
  label: string;
}

const props = defineProps<Props>();

defineEmits<{
  (e: 'update:modelValue', payload): void;
}>();

const selectedEid = defineModel();
const isSelected = computed(() => selectedEid.value === props.eidType);
</script>
<style lang="scss" scoped>
.eid-item-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-100);
  padding: var(--spacing-150);
  box-shadow: var(--shadow-1);
  border-radius: var(--radius-medium);
  height: 100%;
  cursor: pointer;

  &.selected {
    cursor: initial;
    border: 1px solid var(--link-blue);
  }

  .radio-button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-50);

    .radio-button {
      padding: 0;
    }

    .logo {
      height: 20px;
      flex-shrink: 0;
    }
  }

  .slot-container {
    flex-grow: 1;
  }
}
</style>
